<header class="col-12 header-page">
  <h1 class="header__page__content__title">
    Solicitação
  </h1>
</header>
<ng-template #showLoading>
  <spinner [show]="true"></spinner>
</ng-template>
<main class="main__content" *ngIf="diaLimite == true">
  <section class="ngTemplateNaoPossui">
    <p>Não é possível solicitar boletos nos três primeiros e nos três últimos dias úteis de cada mês.</p>
  </section>
</main>
<main class="main__content" *ngIf="diaLimite == false">
  <form [formGroup]="formGroup" class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2 main__page__content__form"
    (ngSubmit)="GenerateInvoice()">
    <section class="content-form">
      <div class="row">
        <div class="col-xs-4 col-xl-4 col-md-6 col-sm-12 mb-2 px-1">
          <label class="label-form">Data de vencimento</label>

          <!-- <input type="date" class="form-control input-form" formControlName="Dat_Prvpg_Blpgt" placeholder="DD-MM-YYYY"
            (ngModelChange)="ValidateExistence()" [min]="minDate" [max]="maxDate" (keydown)="disableTyping($event)"
            (focus)="openCalendar($event)" required> -->

            <div class="input-group">
              <input 
                class="form-control date" 
                (ngModelChange)="ValidateExistence()" 
                formControlName="Dat_Prvpg_Blpgt" 
                placeholder="DD-MM-YYYY" 
                name="date"  
                ngbDatepicker  
                #d2="ngbDatepicker"  
                [markDisabled]="isDisabled" 
                [displayMonths]="1" 
                [navigation]="'none'" 
                [minDate]="dt" 
                [maxDate]="dtm" 
                (focus)="openCalendar($event)" 
                 readonly
                (click)="d2.toggle()"/>
              <div class="input-group-append">
                <button class="btn btn-outline-secondary" (click)="d2.toggle()" type="button">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar" viewBox="0 0 16 16">
                      <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z"/>
                    </svg>
                </button>
              </div>
            </div>



          <small class="form-text text-muted danger ng-star-inserted"
            *ngIf="formGroup.get('Dat_Prvpg_Blpgt')?.hasError('invalidDate') && invalido">
            O campo Data inicio está inválido!
          </small>
        </div>
        <div class="col-xs-4 col-xl-4 col-md-6 col-sm-12 mb-2 px-1">
          <label class="label-form">Valor do aporte</label>
          <input class="form-control input-form" placeholder="R$ 0,00" formControlName="Vlr_Prvst_Iblpgt" maxlength="14"
            [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" currencyMask required />
        </div>
        <div class="col-xs-4 col-xl-4 col-md-6 col-sm-12 mb-2 px-1" id="origem">
          <label class="label-form">Origem de recurso (opcional)</label>
          <ng-select [items]="origemAporte" bindLabel="nome" bindValue="id" placeholder="Este campo é opcional"
            formControlName="Origem">
          </ng-select>
        </div>
      </div>
      <button id="btnSubmit" class="btn button-primary" type="submit" [disabled]="this.loading">
        <div class="d-flex" *ngIf="loading; else showSpan" [@fadeIn]>
          <span>Solicitando...</span>
        </div>
        <ng-template #showSpan>
          <span [@fadeIn]>Solicitar Aporte</span>
        </ng-template>
      </button>
    </section>
  </form>
  <section class="content__resultado__main" *ngIf="!loading; else showLoading" [@fadeIn]>
    <ng-template #loadingGrid>
      <spinner-grid />
    </ng-template>
  </section>
  <div>
    <!-- <section class="main__page__content__section__header" *ngIf="!loadingIntake && intakeHistory && !noContent" [@fadeInOut]> -->
    <section class="main__page__content__section__header" *ngIf="!loadingIntake && intakeHistory && !noContent"
      [@fadeInOut]>
      <section class="col-8 main__page__content__section__header__valores">
        <div class="col-6 p-0">
          <span class="section__header__valores__title">Valor do último aporte: </span>
          <span class="section__header__valores__content">{{intakeHistory?.value | currency:'BRL'}}</span>
        </div>
        <div class="col-6 p-0">
          <span class="section__header__valores__title">Data em que foi gerado: </span>
          <span class="section__header__valores__content">
            {{(intakeHistory?.paymentDate | date: 'dd/MM/yyyy') || 'Ainda' }}</span>
        </div>
      </section>
    </section>
    <div class="main__page__content__section__aviso">
      <span>
        Para atingir os 12% do benefício tributário, você deve fazer um aporte de R$
        {{intakeValue | number:'1.2-2'}}
      </span>
    </div>
    <ng-template #toTwelveSuccess>
      <div>
        <span>Você já alcançou o limite dos 12% para o benefício tributário, mas você
          pode continuar fazendo aportes!</span>
      </div>
    </ng-template>
    <div class="main__page__content__section__aviso__blockquote">
      <blockquote cite="">
        <p>
          O resultado do valor mencionado acima leva em consideração os valores de salários recebidos pela
          Patrocinadora e as contribuições para o Plano III. Não estão computadas as contribuições para o Plano
          Família nem outras fontes de renda como aluguéis, benefício do INSS, etc.
          Quem aplica em Fundos de Pensão pode deduzir até 12% da renda tributável, o que faz com que a alíquota
          do IRPF incida sobre uma base menor, reduzindo o valor do imposto. No entanto, a conta chega mais à
          frente: ao resgatar o investimento no futuro, haverá a incidência de IR – por isso, a estratégia só é
          indicada para uma renda mais alta e para quem pode manter a aplicação no longo prazo.
        </p>
      </blockquote>
    </div>
  </div>
</main>



<header class="col-12 header-page h-apt">
  <h1 class="header__page__content__title historico-apt">
      Histórico
  </h1>
</header>
  <form class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2 main__page__content__form form-ht" [formGroup]="formGroup"
      (ngSubmit)="load()">
      <section class="content-form">
          <div class="row">
              <div class="col-xs-4 col-xl-4 col-md-6 col-sm-12 mb-2 px-1">
                  <label class="label-form">Data inicio</label>
                  <input type="date" class="form-control input-form" formControlName="initialDate"
                      placeholder="DD-MM-YYYY" max="{{today | date:'yyyy-MM-dd'}}">
                  <small class="form-text text-muted danger ng-star-inserted"
                      *ngIf="formGroup.get('initialDate')?.touched && formGroup.get('initialDate')?.invalid">
                      O campo Data inicio está inválido!
                  </small>
              </div>
              <div class="col-xs-4 col-xl-4 col-md-6 col-sm-12 mb-2 px-1">
                  <label class="label-form">Data fim</label>
                  <input type="date" class="form-control input-form" formControlName="finalDate"
                      placeholder="DD-MM-YYYY" max="{{today | date:'yyyy-MM-dd'}}">
                  <small class="form-text text-muted danger ng-star-inserted"
                      *ngIf="formGroup.get('finalDate')?.touched && formGroup.get('finalDate')?.invalid">
                      O campo Data Término está inválido!
                  </small>
              </div>
          </div>

          <button [disabled]="this.loadingHistorico"
          class="btn button-primary col-xl-2 col-lg-3 col-md-4 col-sm-12 mr-xl-1 mr-lg-1" type="submit">
          <div class="d-flex" *ngIf="loadingHistorico; else showSpan" [@fadeIn]>
              <span>Consultando</span>
          </div>
          <ng-template #showSpan>
              <span [@fadeIn]>Consultar</span>
          </ng-template>
      </button>
      </section>

  </form>
  <!-- <div class="content_download_pdf" *ngIf="myContributionRequests && myContributionRequests.length > 0">
      <div>
          <h3 class="content_download_pdf_title">
              Exportar
          </h3>
      </div>
      <section class="d-flex">
          <button [disabled]="this.loadingHistorico">
              <div class="d-flex" *ngIf="loadingCsv; else showLoadingCsv">
                  <span class="spinner-button-export">
                  </span>
              </div>
              <ng-template #showLoadingCsv>
                  <fa-icon [icon]="faExcel" (click)="printCsv()"></fa-icon>
              </ng-template>
          </button>
      </section>
  </div> -->
  <header class="content__header mt-1" *ngIf="myContributionRequests && myContributionRequests.length > 0">
      <h3>Aportes</h3>
      <filtro-dados [pageItens]="5" [totalItens]="formGroup.value.totalFiltered"
          (changeQuantidade)="onChangeQuantidadeItens($event)"
          *ngIf="myContributionRequests && myContributionRequests.length > 0">
      </filtro-dados>
  </header>

  <ng-container #showLoading>
      <spinner [show]="loadingHistorico"></spinner>
    </ng-container>


  <ng-template #naoPossuiAportes>
      <ng-container *ngIf="!loadingHistorico">
          <p class="col-12 ng-template-text">
              Ainda não foi realizado nenhum Aporte
          </p>
      </ng-container>
  </ng-template>
  
  <main *ngIf="myContributionRequests && myContributionRequests.length > 0 else naoPossuiAportes">
    <section class="content__header__table row font-weight-bold">
      <div class="col-3">Data do Pagamento</div>
      <div class="col-3">Valor Pago</div>
      <div class="col-2">Ações</div>
      <div class="col-4">Status</div>
    </section>
  
    <section class="content__main__table mt-1">
      <section class="table__card row align-items-center border-bottom py-2" *ngFor="let item of lista.items; index as i">
        <div class="col-3">
          <span *ngIf="(item.paymentDate | date:'dd/MM/yyyy') !== '01/01/0001'">
            {{ item.paymentDate | date:'dd/MM/yyyy' }}
          </span>
          <span *ngIf="(item.paymentDate | date:'dd/MM/yyyy') == '01/01/0001'">
            Não realizado
          </span>
        </div>
  
        <div class="col-3">
          {{ item?.valor | currency:'BRL':'symbol':'1.2-2':'pt' }}
        </div>
  
        <div class="col-2">
          <a (click)="visualizarAporte(item)">
            <fa-icon class="fa-icon icon-eye" [icon]="faEye"></fa-icon>
          </a>
        </div>
  
        <div class="col-4">
          {{ item?.status }}
        </div>
      </section>
    </section>
  </main>
  
  <footer *ngIf="myContributionRequests && myContributionRequests.length > 0">
      <paginacao [currentPage]="1" [collectionSize]="formGroup.value.totalFiltered"
          [pageSize]="formGroup.value.itemsPerPage" (changeNumber)="onChangePagination($event)">
      </paginacao>
  </footer>